import * as Blockly from 'blockly/core';
import 'blockly/python';
// import { getAllowedOutputs } from './strata_compatibility_checks';

Blockly.Blocks['globe_update_dashboard'] = {
    init: function () {
        this.appendDummyInput()
            .appendField("update dashboard");


        //TODO add proper checks for next and previous statement
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour('#53565a');
        this.setStyle("dashboards")
        this.setTooltip("");
        this.setHelpUrl("");
    }

}